import React from 'react';
import { App } from 'antd';
import { ExpandAltOutlined, IdcardOutlined, CheckCircleOutlined } from '@ant-design/icons';

const ClaimIdCard = ({ data, isPending }) => {
  const { message } = App.useApp();

  return (
    <div>
      <div className="claim-card" style={{ height: '100%' }}>
        <div className="claim-card-title">
          <span className="claim-card-title-icon">🪪</span> Identificación Oficial (INE)
        </div>
        
        <div className="claim-id-header">
          <span className="claim-id-subtitle">Fotografía del documento</span>
          <button className="claim-btn-expand" onClick={() => message.info('Ampliando imagen...')}>
            <ExpandAltOutlined /> Ampliar
          </button>
        </div>
        
        <div className="claim-id-image-container">
          {!data.idImage || data.idImage === 'Pendiente' ? (
            <div className="claim-id-placeholder">
              <IdcardOutlined style={{ fontSize: 48, color: '#475569', marginBottom: 12 }} />
              <span>Identificación Pendiente</span>
            </div>
          ) : (
            <img 
              src={data.idImage} 
              alt="Identificación Oficial" 
              className="claim-id-image" 
            />
          )}
        </div>

        <div className="claim-alert info">
          <CheckCircleOutlined />
          Asegúrate de que la imagen sea legible y que todos los datos sean visibles.
        </div>
      </div>
    </div>
  );
};

export default ClaimIdCard;
